var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4569 80.588H24.5255V17.3984C24.5255 15.998 24.5 14.6727 24.4762 13.4368C24.4352 11.3096 24.3993 9.44771 24.5076 7.92534C24.593 6.72439 24.7626 5.89615 25.0105 5.3932C25.1275 5.15591 25.2393 5.0386 25.3238 4.97938C25.3978 4.92751 25.4996 4.88477 25.6781 4.88477H74.0926C74.2711 4.88477 74.3804 4.92763 74.4645 4.9853C74.5588 5.04994 74.6784 5.17366 74.8037 5.41372C75.0679 5.91998 75.2598 6.75014 75.3707 7.94674C75.5283 9.64586 75.5053 11.7944 75.4789 14.257C75.4682 15.2555 75.4569 16.3056 75.4569 17.3984V80.588Z",
    className: "svgStroke",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1904 76.2146C71.1208 76.4266 71.0539 76.5598 71.0056 76.6361H28.9769C28.9286 76.5598 28.8617 76.4266 28.7921 76.2146C28.6058 75.6471 28.4778 74.7547 28.4778 73.6009V13.0723C28.4778 11.9186 28.6058 11.0262 28.7921 10.4586C28.8617 10.2466 28.9286 10.1134 28.9769 10.0371H71.0056C71.0539 10.1134 71.1208 10.2466 71.1904 10.4586C71.3767 11.0262 71.5047 11.9186 71.5047 13.0723V73.6009C71.5047 74.7547 71.3767 75.6471 71.1904 76.2146Z",
    className: "svgStroke",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1636 94.1792H28.8185C26.4596 94.1792 24.5254 92.245 24.5254 89.886V81.623H75.4567V89.886C75.4567 92.245 73.5226 94.1792 71.1636 94.1792Z",
    className: "svgStroke",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.961 87.9141H68.8404V88.5606H54.961V87.9141ZM31.1419 87.9141H45.0213V88.5606H31.1419V87.9141Z",
    className: "svgStroke",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4087 89.6348C40.39 89.6482 40.3707 89.6615 40.351 89.6748C39.8298 90.0263 39.0395 90.2813 38.0816 90.2813C37.1237 90.2813 36.3334 90.0263 35.8122 89.6748C35.7925 89.6615 35.7732 89.6482 35.7545 89.6348H40.4087Z",
    className: "svgStroke",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.e078be85.svg";
export { ForwardRef as ReactComponent };